module.exports = __webpack_public_path__ + "static/media/students_placement2026.4526b48d.png";